import styles from './style.module.css';
import sprof from "../../../assets/sprof.svg";
import wallet from "../../../assets/wallet.svg";
import call from "../../../assets/call.svg";
import customerProfile from "../../../assets/customerProfile.jpg";
import business_type from "../../../assets/business_type.svg";
import info from "../../../assets/info.svg";

import { useDispatch, useSelector } from 'react-redux';
import { get_currencyCode, get_id, get_lang } from '../../../helper/UserData/userdate';
import { Voip_OutgoingCall } from '../../../Redux/actions/actions';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useCallback } from 'react';
import { OfferingDetailsOpen, PriceDetailsOpen, SetViewOrderPickupDropoffDetails, show_eventTimeLine } from '../../../Redux/actions/actionNames';
import Tag from '../../../design-system/lib/Tag';
import delivery_method from "../../../assets/IconProvider/delivery_method.svg";
import Typography from '../../../design-system/lib/Typography';
import Button from '../../../design-system/lib/Button';
import { COPY, options_color, options_ic } from '../../../assets';
import { snack } from '../../../utils/SnackbarUtilsConfigurator';
import IconProvider from '../../../design-system/lib/IconProvider';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import useMeasure from 'react-use-measure';

export const CustomerService = () => {
    const customer = useSelector((state) => state.ViewTravel.pureData.customer)
    const business = useSelector((state) => state.ViewTravel.pureData.business)
    const orderId = useSelector((state) => state.ViewTravel.pureData.id)
    const service = useSelector((state) => state.ViewTravel.pureData.service)
    const customerId = useSelector((state) => state.ViewTravel.pureData.customerId)
    const customerType = useSelector((state) => state.ViewTravel.pureData.customerType)
    const { t, i18n } = useTranslation();
    const pickup_dropoff_details = useSelector((state) => state.ViewTravel.pickup_dropoff_details)
    const order_customField = useSelector((state) => state.ViewTravel.pureData.customFields)
    const order_customFieldDefinitions = useSelector((state) => state.ViewTravel.pureData.customFieldDefinitions ) || []

    const dispatch = useDispatch();
    const orderType = useSelector((state) => state.ViewTravel.pureData.type)
    const deliveryMethod = useSelector((state) => state.ViewTravel.pureData.deliveryMethod)
    const pureData = useSelector((state) => state.ViewTravel.pureData)
  const [ref, { height }] = useMeasure()


    function serviceOptionsNameExtracter() {
        let names = [];
        if (service) {
            service.options.map((option) => {
                if (option.type === "boolean") {
                    names.push(option.title);
                } else {
                    names.push(option.dataTitle);
                }
            });
            return names
        } else {
            return [];
        }
    };

    function makeOutgoingCall() {
        dispatch(Voip_OutgoingCall(dispatch, {
            "to": customer
                ? customer.phone
                : business
                    ? business.phone
                    : "",
            "orderId": orderId,
            "customerId": customerId,
            "driverId": null,
            "dispatcherId": get_id()
        }))

    }


    const countServiceOptions = useCallback(() => {

 

        let count = 0;

        for (const key in order_customField) {
            const value = order_customField[key];

            if( value ==  null){

            }else if (typeof value === "boolean") {
                if (value === true) count++;
            } else {
                count++;
            }
        }

        return service.options.length +  count


    }, [order_customField, service]);




    const dropOffInfo = useCallback(() => {
        if (pickup_dropoff_details && String(pickup_dropoff_details.type) == String("ServiceOptions")) {
            dispatch(SetViewOrderPickupDropoffDetails(null))
        } else {
            dispatch(SetViewOrderPickupDropoffDetails({ type: "ServiceOptions", data: service.options , customField : order_customField , order_customFieldDefinitions : order_customFieldDefinitions  }))
        }
        dispatch(OfferingDetailsOpen(false))
        dispatch(show_eventTimeLine(false))
        dispatch(PriceDetailsOpen(false))
    }, [pickup_dropoff_details , order_customField]);


        const pickupInfo = useCallback(() => {
            if (pickup_dropoff_details && String(pickup_dropoff_details.type) == "Customerinfo") {
                dispatch(SetViewOrderPickupDropoffDetails(null))
            } else {
                dispatch(SetViewOrderPickupDropoffDetails({ type: "Customerinfo", data: customer ? customer : business  ,isCustomerDriver : true , isBussiness : pureData.customerType == "business" }))
            }
            dispatch(OfferingDetailsOpen(false))
            dispatch(show_eventTimeLine(false))
            dispatch(PriceDetailsOpen(false))
    
        }, [customer, business , pickup_dropoff_details , pureData]);


        console.log("custosdsdsdsmer",height)

    return <div className={styles.customerService} style={{height:"auto"}}>
        <div style={{display:"flex",flexDirection:"row",justifyContent:"start",alignItems:"center" ,flexWrap:"wrap"}}  ref={ref}>
                <span className={styles.profileContainer}>
            <img className={styles.cprof} src={`${customer &&
                customer.avatarPhoto &&
                customer.avatarPhoto.length !== 0
                ? customer.avatarPhoto
                : customerProfile
                }`} />
            <img className={styles.sprof} src={customerType == "individual" ? sprof : business_type} />
        </span>

        <div className={styles.namePhoneContainer} style={{flexDirection:"column" , gap :"2px"}}>
            <span className={styles.name}>{customer
                ? customer.name
                : business
                    ? business.title
                    : ""}</span>
            {/* <span className={styles.phone}> {customer
                ? customer.phone
                : business
                    ? business.phone
                    : ""} </span> */}
                            <CopyToClipboard text={customer.phone}
                                onCopy={() => snack.success(t("Saved"))}>
                                <Typography weight='Subtitle_Tiny_Regular' text={<>{customer.phone} <IconProvider Icon={COPY} size='12' /></>} style={{ display: "flex", fleDirection: "row", justifyContainer: "center", alignItems: "start", gap: "4px", cursor: "pointer" }} />
                              </CopyToClipboard>
        </div>

 { (height <= 48 &&["PickupDelivery"].indexOf(orderType) == -1) && <span className={styles.wallet}> <img src={wallet} /> {
            customer &&
            Number(customer.balance).toLocaleString(
                get_lang(),
                {
                    style: "currency",
                    currency: get_currencyCode(),
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }
            )
        } </span>}
        <img className={styles.call} src={call} onClick={() => makeOutgoingCall()}  style={{marginInlineEnd:"8px" ,marginInlineStart:"auto"}} />
        <img className={clsx(styles.call, (pickup_dropoff_details && String(pickup_dropoff_details.type) == "Customerinfo") && styles.infoActive)}src={info} onClick={pickupInfo}  />       
       { (height > 48 &&["PickupDelivery"].indexOf(orderType) == -1) && <span className={styles.wallet}> <img src={wallet} /> {
            customer &&
            Number(customer.balance).toLocaleString(
                get_lang(),
                {
                    style: "currency",
                    currency: get_currencyCode(),
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }
            )
        } </span>}
        </div>

 
        <hr className={styles.hr} />

        <div className={styles.xdop} id="viewOrder_customerService">
            <img src={
                    service &&
                    service.icon
                } className={styles.serviceImage} />
                <div className={styles.serviceName} style={{
                    display:"grid"
                }}> 
                    <span style={{
                        textDecoration: 'none',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                    
                    >{service && service.title}</span>
                    <Typography weight='Subtitle_Tiny_Regular' text={t("Service")} textColor='rgba(128, 128, 128, 1)' style={{ color: "rgba(128, 128, 128, 1)" }} />  
                    
                </div>

            <Tag backgroundColor='GrayUltraLight' color='TextDark' size='Large' weight='Body_Middle_Medium' icon={delivery_method} iconSize='16' text={deliveryMethod.title} style={{ alignSelf: "center", marginInlineStart: "8px", marginInlineEnd: "12px" , maxWidth:"150px"}} className={styles.delivery_method} />

            {countServiceOptions() > 0 && <Button size='Medium' icon={options_color} type='Secondary' onClick={() => { dropOffInfo() }} isActive={pickup_dropoff_details && String(pickup_dropoff_details.type) == String("ServiceOptions")} style={{ alignSelf: "center", marginInlineStart: "auto", marginInlineEnd: "16px" }} text={<>  <span style={{ backgroundColor: "rgba(16, 128, 255, 0.08)", borderRadius: "50%", width: "16px", height: "16px", color: "rgba(16, 128, 255, 1)" }}>{countServiceOptions()}</span> </>} />}

            {/* <div className={styles.serviceOptions}>

                <Tag backgroundColor='GrayUltraLight' color='TextDark' size='Large' weight='Body_Middle_Medium' icon={delivery_method} iconSize='16' text={deliveryMethod.title} />

               {service.options?.length > 0 && <Button size='Medium' icon={options_color} type='Secondary' onClick={() => { dropOffInfo() }} isActive={pickup_dropoff_details && String(pickup_dropoff_details.type) == String("ServiceOptions")} text={<>{t("Options")} <span style={{ backgroundColor: "rgba(16, 128, 255, 0.08)", borderRadius: "50%", width: "16px", height: "16px", color: "rgba(16, 128, 255, 1)" }}>{service.options.length}</span> </>} />}

            </div> */}
        </div>


    </div>

};




